<p-toast [style]="{float: 'left'}" position="center" key="r" [baseZIndex]="1000">
  <ng-template let-content pTemplate="content">
    <div style="text-align: left">
      <h3>{{content.summary}}</h3>
      <div innerHtml="{{content.detail}}">
        <mat-divider>
        </mat-divider>
      </div>
      <button style="float: right" type="button" pButton label="Ok" (click)="messageService.clear();"
      class="ui-button"></button>
    </div>
  </ng-template>
</p-toast>


<div class="container-fluid rate-summary-report">
  <br>
    <h2>Rate Summary Report</h2>
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=true [showBedrooms]=true [showSeasons]=false [showStartDate]=false
    [showEndDate]=false (doSearchCB)="onSearchSubmit($event)"></app-search-template>
    <br><br>

    <p-table #dt [value]="advertisedRateRows" [columns]="scrollingColumns" scrollDirection="both" [frozenWidth]="frozenWidth"
      [scrollable]="true" [scrollHeight]="innerHeight +'px'" sortMode="multiple" [loading]="formLoading"
      [ngStyle]="{'width': 'auto'}">
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of frozenColumns; track col) {
            <th style="width:75px;height:115px;padding: .2em .2em !important;"
              [pSortableColumn]="col.field" pFrozenColumn>
              <div class="d-flex flex-column">
                {{col.header}}
                <div class="d-block w-100">@if (col.field === 'propertyCode') {
                  <input (click)="clickOnFilter($event)" style="width:50px"
                    pInputText type="text"
                    (input)="dt.filter($event.target.value, col.field, 'contains')">
                }
              </div>
              <div class="d-block w-100">@if (col.field === 'rateBucketName') {
                <input (click)="clickOnFilter($event)" style="width:50px"
                  pInputText type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')">
              }
            </div>
            <div class="d-block w-100">@if (col.field === 'bedrooms') {
              <input (click)="clickOnFilter($event)" style="width:40px"
                pInputText type="text"
                (input)="dt.filter($event.target.value, col.field, 'startsWith')">
            }</div>
            <div class="d-block w-100">@if (col.field === 'rateBucketAdjusterPct') {
              <input (click)="clickOnFilter($event)" style="width:50px"
                pInputText type="text"
                (input)="dt.filter($event.target.value, col.field, 'contains')">
            }</div>
          </div>
        </th>
      }
      @for (col of columns; track col) {
        <th style="width:175px;height:115px;padding: .2em .2em !important;"
          [pSortableColumn]="col.field">
          {{col.header}}
          <div>@if (col.field === 'propertyCode') {
            <input (click)="clickOnFilter($event)" style="width:50px"
              pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
          }
        </div>
        <div>@if (col.field === 'rateBucketName') {
          <input (click)="clickOnFilter($event)" style="width:50px"
            pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
        }
      </div>
      <div>@if (col.field === 'bedrooms') {
        <input (click)="clickOnFilter($event)" style="width:40px" pInputText
          type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
      }</div>
      <!-- <div><input (click)="clickOnFilter($event)" style="width:100px" *ngIf="col.field === 'adrDevelopmentName'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')"></div> -->
      <div>@if (col.field === 'rateBucketAdjusterPct') {
        <input (click)="clickOnFilter($event)" style="width:50px"
          pInputText type="text"
          (input)="dt.filter($event.target.value, col.field, 'contains')">
      }</div>
    </th>
  }
</tr>
</ng-template>
<ng-template pTemplate="body" let-rowData let-columns="columns">
  <tr>
    @for (col of frozenColumns; track col) {
      <td style="width:75px;height:140px; padding: .2em .2em !important;"
        [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
        [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)"
        pFrozenColumn>
        @if (col.field === 'rateBucketName') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'bedrooms') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'adrDevelopmentName') {
          <span>
            {{calcYearlyGrossRev(rowData).yrListPrice | currency : 'USD' : 'symbol' : '1.0-0'}}<br>
            <b>{{calcYearlyGrossRev(rowData).yrPropertyListPrice | currency : 'USD' : 'symbol' :
            '1.0-0'}}</b><br>
            {{calcYearlyGrossRev(rowData).yrYMDiscFloorPrice | currency : 'USD' : 'symbol' :
            '1.0-0'}}<br>
            <span>&nbsp;</span><br>
            {{calcYearlyGrossRev(rowData).yrListPriceAdj | currency : 'USD' : 'symbol' : '1.0-0'}}
          </span>
        }
        @if (col.field === 'propertyCode') {
          <span>
            <a style=" text-decoration: none;"
              [routerLink]="['/property-edit', rowData[0].shortTermRentalId]"
            target="_blank">{{rowData[col.field]}}</a>
          </span>
        }
        @if (col.field === 'rateBucketAdjusterPct') {
          <span>
            <input #rateBucketAdjusterPct
              (change)="onRateBucketAdjusterPctChange(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"
              pInputText type="text" value="{{formatPercent(rowData.rateBucketAdjusterPct)}}"
              style="width:65px;margin-bottom:3px;">
							<a #cl3 href="javascript:" (click)="onRateBucketAdjusterPctSave(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value);rateBucketAdjusterPct.style.backgroundColor = 'transparent';
							cl3.style.visibility = 'hidden';" style="margin-left:2px;visibility:hidden;color:red"><i
              class="pi pi-save"></i></a>
              <br>&nbsp;
                <a #cl1 href="javascript:"
                  (click)="decRateBucketAdjPct(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                class="pi pi-minus"></i></a>&nbsp;&nbsp;&nbsp;
                <a #cl2 href="javascript:"
                  (click)="incRateBucketAdjPct(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                class="pi pi-plus"></i></a>
              </span>
            }
            @if (col.field!='rateBucketName'&&col.field!='bedrooms'&&col.field!='adrDevelopmentName'&&col.field!='rateBucketAdjusterPct'&&col.field!='propertyCode'&&rowData[col.field]) {
              <span
                >
                <input #listPrice
                  (change)="onListPriceChange(rowData[col.field].rateBucketDetailId,listPrice.value);cl6.style.visibility = 'visible';listPrice.style.backgroundColor = '#FFCCCB';"
                  type="text" value="{{calcListPrice(rowData[col.field])}}"
                  style="width:65px;margin-bottom:3px;">&nbsp;
                  <a #cl4 href="javascript:"
                    (click)="decListPrice(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i
                  class="pi pi-minus"></i></a>&nbsp;
                  <a #cl5 href="javascript:"
                    (click)="incListPrice(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i
                  class="pi pi-plus"></i></a>&nbsp;
                  <a #cl6 href="javascript:"
                    (click)="onRateBucketListPriceSave(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = 'transparent';cl6.style.visibility = 'hidden';"
                    style="margin-left:2px;visibility:hidden;color:red"><i class="pi pi-save"></i></a>
                    <br>
                      <span>
                        <b>{{calcPropertyListPrice(rowData[col.field]) | currency : 'USD' : 'symbol' :
                        '1.0-0'}}</b>
                      </span>
                      @if (rowData[col.field].rateBucketAdjusterPct) {
                        <span>
                          {{rowData[col.field].rateBucketAdjusterPct | percent}}
                        </span>
                      }
                      <br>
                        <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)">
                          <span>
                            {{calcYMDiscFloorPrice(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}
                          </span>
                          @if (rowData[col.field].discountMaxPercent||rowData[col.field].discountLookForwardDays) {
                            <span
                              >
                              -{{rowData[col.field].discountMaxPercent |
                              percent}}&nbsp;{{rowData[col.field].discountLookForwardDays}}d
                            </span>
                          }
                        </span>
                        <br>
                          <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)">
                            @if (rowData[col.field].minimumPriceSetByManager) {
                              <span>
                                {{rowData[col.field].minimumPriceSetByManager | currency : 'USD' : 'symbol' :
                                '1.0-0'}}
                              </span>
                            }
                            @if (rowData[col.field].minStayExpected) {
                              <span>
                                {{rowData[col.field].minStayExpected}}d
                                <span style="padding:2px;"
                                  [style.background-color]="calcMinListPrice(rowData[col.field]).color">{{calcMinListPrice(rowData[col.field]).rate
                                | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                              </span>
                              }&nbsp;
                              @if (rowData[col.field].seasonOccupancy) {
                                <span>
                                  {{rowData[col.field].seasonOccupancy | percent}}
                                </span>
                              }
                            </span>
                            <br>
                              <span>
                                {{calcListPriceAdjPct(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}
                              </span>
                              <span>
                                {{rowData[col.field].listPriceAdjustmentPercent | percent}}
                                {{rowData[col.field].listPriceAdjustmentAmount | percent}}
                              </span>
                            </span>
                          }
                        </td>
                      }
                      @for (col of columns; track col) {
                        <td style="width:175px;height:140px; padding: .2em .2em !important;"
                          [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
                          [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)">
                          @if (col.field === 'rateBucketName') {
                            <span>
                              {{rowData[col.field]}}
                            </span>
                          }
                          @if (col.field === 'bedrooms') {
                            <span>
                              {{rowData[col.field]}}
                            </span>
                          }
                          @if (col.field === 'adrDevelopmentName') {
                            <span>
                              {{calcYearlyGrossRev(rowData).yrListPrice | currency : 'USD' : 'symbol' : '1.0-0'}}<br>
                              <b>{{calcYearlyGrossRev(rowData).yrPropertyListPrice | currency : 'USD' : 'symbol' :
                              '1.0-0'}}</b><br>
                              {{calcYearlyGrossRev(rowData).yrYMDiscFloorPrice | currency : 'USD' : 'symbol' :
                              '1.0-0'}}<br>
                              <span>&nbsp;</span><br>
                              {{calcYearlyGrossRev(rowData).yrListPriceAdj | currency : 'USD' : 'symbol' : '1.0-0'}}
                            </span>
                          }
                          @if (col.field === 'propertyCode') {
                            <span>
                              <a style=" text-decoration: none;"
                                [routerLink]="['/property-edit', rowData[0].shortTermRentalId]"
                              target="_blank">{{rowData[col.field]}}</a>
                            </span>
                          }
                          @if (col.field === 'rateBucketAdjusterPct') {
                            <span>
                              <input #rateBucketAdjusterPct
                                (change)="onRateBucketAdjusterPctChange(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"
                                pInputText type="text" value="{{formatPercent(rowData.rateBucketAdjusterPct)}}"
                                style="width:65px;margin-bottom:3px;">
							<a #cl3 href="javascript:" (click)="onRateBucketAdjusterPctSave(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value);rateBucketAdjusterPct.style.backgroundColor = 'transparent';
							cl3.style.visibility = 'hidden';" style="margin-left:2px;visibility:hidden;color:red"><i
                                class="pi pi-save"></i></a>
                                <br>&nbsp;
                                  <a #cl1 href="javascript:"
                                    (click)="decRateBucketAdjPct(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                                  class="pi pi-minus"></i></a>&nbsp;&nbsp;&nbsp;
                                  <a #cl2 href="javascript:"
                                    (click)="incRateBucketAdjPct(rowData[0].shortTermRentalId,rateBucketAdjusterPct.value,rowData);rateBucketAdjusterPct.style.backgroundColor = '#FFCCCB';cl3.style.visibility = 'visible';"><i
                                  class="pi pi-plus"></i></a>
                                </span>
                              }
                              @if (col.field!='rateBucketName'&&col.field!='bedrooms'&&col.field!='adrDevelopmentName'&&col.field!='rateBucketAdjusterPct'&&col.field!='propertyCode'&&rowData[col.field]) {
                                <span
                                  >
                                  <input #listPrice
                                    (change)="onListPriceChange(rowData[col.field].rateBucketDetailId,listPrice.value);cl6.style.visibility = 'visible';listPrice.style.backgroundColor = '#FFCCCB';"
                                    type="text" value="{{calcListPrice(rowData[col.field])}}"
                                    style="width:65px;margin-bottom:3px;">&nbsp;
                                    <a #cl4 href="javascript:"
                                      (click)="decListPrice(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i
                                    class="pi pi-minus"></i></a>&nbsp;
                                    <a #cl5 href="javascript:"
                                      (click)="incListPrice(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = '#FFCCCB';cl6.style.visibility = 'visible';"><i
                                    class="pi pi-plus"></i></a>&nbsp;
                                    <a #cl6 href="javascript:"
                                      (click)="onRateBucketListPriceSave(rowData[col.field].rateBucketDetailId,listPrice.value);listPrice.style.backgroundColor = 'transparent';cl6.style.visibility = 'hidden';"
                                      style="margin-left:2px;visibility:hidden;color:red"><i class="pi pi-save"></i></a>
                                      <br>
                                        <span>
                                          <b>{{calcPropertyListPrice(rowData[col.field]) | currency : 'USD' : 'symbol' :
                                          '1.0-0'}}</b>
                                        </span>
                                        @if (rowData[col.field].rateBucketAdjusterPct) {
                                          <span>
                                            {{rowData[col.field].rateBucketAdjusterPct | percent}}
                                          </span>
                                        }
                                        <br>
                                          <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)">
                                            <span>
                                              {{calcYMDiscFloorPrice(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}
                                            </span>
                                            @if (rowData[col.field].discountMaxPercent||rowData[col.field].discountLookForwardDays) {
                                              <span
                                                >
                                                -{{rowData[col.field].discountMaxPercent |
                                                percent}}&nbsp;{{rowData[col.field].discountLookForwardDays}}d
                                              </span>
                                            }
                                          </span>
                                          <br>
                                            <span (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)">
                                              @if (rowData[col.field].minimumPriceSetByManager) {
                                                <span>
                                                  {{rowData[col.field].minimumPriceSetByManager | currency : 'USD' : 'symbol' :
                                                  '1.0-0'}}
                                                </span>
                                              }
                                              @if (rowData[col.field].minStayExpected) {
                                                <span>
                                                  {{rowData[col.field].minStayExpected}}d
                                                  <span style="padding:2px;"
                                                    [style.background-color]="calcMinListPrice(rowData[col.field]).color">{{calcMinListPrice(rowData[col.field]).rate
                                                  | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                                                </span>
                                                }&nbsp;
                                                @if (rowData[col.field].seasonOccupancy) {
                                                  <span>
                                                    {{rowData[col.field].seasonOccupancy | percent}}
                                                  </span>
                                                }
                                              </span>
                                              <br>
                                                <span>
                                                  {{calcListPriceAdjPct(rowData[col.field]) | currency : 'USD' : 'symbol' : '1.0-0'}}
                                                </span>
                                                <span>
                                                  {{rowData[col.field].listPriceAdjustmentPercent | percent}}
                                                  {{rowData[col.field].listPriceAdjustmentAmount | percent}}
                                                </span>
                                              </span>
                                            }
                                          </td>
                                        }
                                      </tr>
                                    </ng-template>
                                  </p-table>
                                </div>
